import { GUIControlEvent } from "@/gui/GUIControlEvent";

/**
 * GUIControlEventFactory class.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file GUIControlEventFactory.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 */
export class GUIControlEventFactory {

  static generateEventObject(): GUIControlEvent{
    return new GUIControlEvent();
  }

}